import React from 'react';

import { ModalWrapper } from 'shared/modals/v2-wrapper';
import { DesktopOnly, MobileOnly } from 'shared/components';

import { ModalContainer, BottomDrawer } from 'src/components/core';
import { withModalControlsHook, ModalComponentProps } from 'src/components/modals/with-modal-controls-hook';
import { Loyalty } from 'src/components/loyalty/modal';
import { Statuses } from 'src/components/loyalty/use-loyalty/types';
import type { LoyaltyEnrollmentSurface } from 'src/utils/analytics/events';

export type LoyaltyModalDataValue = {
  surface: LoyaltyEnrollmentSurface;
};

type LoyaltyModalProps = ModalComponentProps<LoyaltyModalDataValue, { status: Statuses } | undefined>;

const LoyaltyModal = ({ onClose, containerProps, data }: LoyaltyModalProps): JSX.Element => (
  <>
    <DesktopOnly mediaQuery='sm'>
      <ModalWrapper open>
        <ModalContainer width='470px' p='32px' {...containerProps}>
          <Loyalty onClose={onClose} surface={data.surface} />
        </ModalContainer>
      </ModalWrapper>
    </DesktopOnly>
    <MobileOnly mediaQuery='xs'>
      <BottomDrawer open hideExitIcon onClose={onClose} shouldCalculateIframeBottom {...containerProps}>
        <Loyalty onClose={onClose} surface={data.surface} />
      </BottomDrawer>
    </MobileOnly>
  </>
);

const [LoyaltyController, useLoyaltyModal] = withModalControlsHook<
  LoyaltyModalDataValue,
  { status: Statuses } | undefined
>(LoyaltyModal);

export { useLoyaltyModal, LoyaltyController };
